// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/FeaturedContent/index.css
// module id = 3103
// module chunks = 0